import { lazy } from 'react';
import { isPublicSitePageEnabled } from '@/publicSite/publicSiteConfig';
import type { AppRouteDefinition } from './routes';

const DocsPage = lazy(async () => {
  const module = await import('../../pages/DocsPage');
  return { default: module.DocsPage };
});

const ModulesPage = lazy(async () => {
  const module = await import('../../pages/ModulesPage');
  return { default: module.ModulesPage };
});

const PricingPage = lazy(async () => {
  const module = await import('../../pages/PricingPage');
  return { default: module.PricingPage };
});

export const publicSiteRouteDefinitions: AppRouteDefinition[] = [
  {
    key: 'docs',
    path: '/docs',
    enabled: isPublicSitePageEnabled('docs'),
    title: 'Docs',
    element: () => <DocsPage />,
  },
  {
    key: 'pricing',
    path: '/plans',
    enabled: isPublicSitePageEnabled('pricing'),
    title: 'Plans for QA Reporting and Test Results Analytics',
    description:
      'Compare FlowQA Trial, Solo, and Team plans for QA reporting, test results analytics, and CI pipeline quality visibility.',
    element: () => <PricingPage />,
  },
  {
    key: 'modules',
    path: '/modules',
    enabled: isPublicSitePageEnabled('modules'),
    title: 'Modules',
    description: 'Review FlowQA module positioning and public information architecture locally.',
    element: () => <ModulesPage />,
  },
];
